import { BUILD_ENVIRONMENTS } from '@src/config/constants'
import { IS_PROD_BUILD } from '@src/config/env'

import Product, { IProduct } from '../../domains/Product/Product'
import QuinceApiError from '../../domains/quince-api-error'
import filterFalsy from '../../utils/filterFalsy'
import { sandServicesHttpClient } from '../../utils/HttpClient'

import { GetProductRequest } from './productService.types'

/**
 * API Configuration Rules:
 * - useLite=false: Executes full enrichment based on provided options
 * - useLite=true: Executes lite enrichment, ignoring provided options
 * - options=ENRICH_REFRESH_LITE: Forces lite enrichment regardless of useLite flag. Other options passed will also be enriched if useLite is false.
 * - options=ENRICH_ONLY_TAGS: Restricts enrichment to tags only. Value of useLite doesnt matter. Other Options passed are ignored.
 */
export async function fetchAndEnrichProducts(fetchProductRequest?: GetProductRequest): Promise<Product[]> {
  const {
    spids = undefined,
    internalProductIds = undefined,
    contentfulProductIds,
    options = undefined,
    useLite = false,
    zipCode = undefined,
    extraParams = undefined,
  } = fetchProductRequest ?? {}
  let productList: IProduct[] = []
  if ((spids?.length ?? 0) == 0 && (contentfulProductIds?.length ?? 0) == 0 && (internalProductIds?.length ?? 0) == 0) {
    return []
  }

  try {
    const { data: products } = await sandServicesHttpClient.get<IProduct[]>('/products/enrich', {
      params: {
        ...extraParams,
        productIds: spids?.join(','),
        internalProductIds: internalProductIds?.join(','),
        contentfulProductIds: contentfulProductIds?.join(','),
        options: options?.join(','),
        zipCode: zipCode,
        environment: IS_PROD_BUILD ? BUILD_ENVIRONMENTS.PROD.toUpperCase() : BUILD_ENVIRONMENTS.STAGE.toUpperCase(),
        useLite,
      },
    })
    productList = products
  } catch (e) {
    throw new QuinceApiError({
      error: e as Error,
      message: 'Failed while fetching products enrich getProducts() runtime',
      apiName: 'PRODUCTS_ENRICH_FETCH',
      data: {
        fetchProductRequest,
      },
    })
  }

  return filterFalsy(productList).map(x => new Product(x))
}
